'use es6';

import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import useInterval from '../hooks/useInterval';
var animationDelay = 500;
export default (function () {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      dots = _useState2[0],
      setDots = _useState2[1];

  var addDot = function addDot() {
    var newDots = dots + ".";

    if (newDots.length > 3) {
      newDots = '';
    }

    setDots(newDots);
  };

  useInterval(addDot, animationDelay);
  return /*#__PURE__*/_jsx("span", {
    className: "loading-dots",
    children: dots
  });
});